<template>
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">
          <translate>Application Visibility Filters</translate>
        </h4>
      </div>

      <div class="card-body">
        <p class="text-muted">
          <translate
            >Hide applications from specific countries across all your
            views.</translate
          >
        </p>
        <div
          class="row"
          v-for="filter in payload.application_visibility_filters"
          :key="filter.field.name"
        >
          <FormGroupCheckbox
            class="col-md-3"
            :label="filter.field.label"
            v-model="filter.checked"
          />
          <div class="col-md-2">
            <multiselect
              :disabled="!filter.checked"
              label="label"
              track-by="value"
              :options="operatorOptions"
              v-model="filter.operator"
              :show-labels="false"
            ></multiselect>
          </div>
          <div
            class="col-md-7 d-flex justify-content-between align-items-center"
          >
            <multiselect
              :loading="false"
              :disabled="!filter.checked"
              :options="filter.options"
              label="option_name"
              :internal-search="true"
              v-model="filter.value"
              :multiple="true"
              track-by="option_id"
              @search-change="handleSearchChange($event, filter)"
              :show-labels="false"
              :show-no-options="false"
              :placeholder="
                !filter.disabledInput ? $gettext('Type to Search...') : ''
              "
            >
              <span slot="noResult"><translate>No results</translate></span>
            </multiselect>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-button @click="handleUpdateFilter" variant="info"
              ><translate>Update</translate></b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FormGroupCheckbox from "@/components/FormGroups/FormGroupCheckbox.vue";
import Multiselect from "vue-multiselect";
import { mapActions, mapGetters } from "vuex";

const VisibilityOperator = Object.freeze({
  ShowOnly: { value: "=", label: "" },
  Exclude: { value: "!=", label: "" }
});

export default {
  components: { Multiselect, FormGroupCheckbox },
  created() {
    VisibilityOperator.ShowOnly.label = this.$gettext("Show only");
    VisibilityOperator.Exclude.label = this.$gettext("Exclude");

    this.payload.application_visibility_filters = this.payload.application_visibility_filters.map(
      payloadFilter => {
        const currentFilter = this.applicationVisibilityFilters.find(filter => {
          return payloadFilter.field.name === filter.field;
        });

        if (currentFilter) {
          payloadFilter.checked = true;
          payloadFilter.value = currentFilter.value;
          payloadFilter.operator =
            currentFilter.operator === "="
              ? VisibilityOperator.ShowOnly
              : VisibilityOperator.Exclude;
        }
        return payloadFilter;
      }
    );

    // Refresh saved option_names to match current UI language
    const savedCodes = [
      ...new Set(
        this.applicationVisibilityFilters.flatMap(f =>
          f.value.map(v => v.option_id)
        )
      )
    ];
    if (savedCodes.length > 0) {
      this.$http
        .get(`ats/filter-options/country?codes=${savedCodes.join(",")}`)
        .then(({ data }) => {
          const nameMap = data.reduce((map, c) => {
            map[c.option_id] = c.option_name;
            return map;
          }, {});
          this.payload.application_visibility_filters.forEach(filter => {
            filter.value = filter.value.map(v => ({
              ...v,
              option_name: nameMap[v.option_id] || v.option_name
            }));
          });
        });
    }
  },
  data() {
    return {
      payload: {
        application_visibility_filters: [
          {
            checked: false,
            field: { name: "country", label: this.$gettext("Country") },
            operator: VisibilityOperator.Exclude,
            value: [],
            options: [],
            optionsEndpoint: "ats/filter-options/country"
          },
          {
            checked: false,
            field: { name: "ip_country", label: this.$gettext("IP Country") },
            operator: VisibilityOperator.Exclude,
            value: [],
            options: [],
            optionsEndpoint: "ats/filter-options/country"
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters("me", ["applicationVisibilityFilters"]),
    operatorOptions() {
      return Object.values(VisibilityOperator);
    },
    parsedPayload() {
      return {
        application_visibility_filters: this.payload.application_visibility_filters
          .filter(({ checked }) => checked === true)
          .map(filter => {
            return {
              field: filter.field.name,
              operator: filter.operator.value,
              value: filter.value
            };
          })
      };
    }
  },
  methods: {
    ...mapActions("me", ["updateApplicationVisibilitySetting"]),
    ...mapActions("form", ["submit"]),
    handleUpdateFilter() {
      this.submit(() =>
        this.updateApplicationVisibilitySetting(this.parsedPayload)
      )
        .then(() => {
          this.$toast.open({
            message: "Done!",
            type: "success"
          });
        })
        .catch(({ response }) => {
          if (response.status === 422) {
            this.$toast.open({
              message: this.$gettext(
                "Please select at least one value for each checked filters"
              ),
              type: "error"
            });
          }
        });
    },
    handleSearchChange(q, filter) {
      const url = `${filter.optionsEndpoint}?&q=${q}`;
      this.$http.get(url).then(({ data }) => (filter.options = data));
    }
  }
};
</script>
